module.exports = __webpack_public_path__ + "static/media/sailboat_active_ic.cbed006f.svg";